import React, { FC } from "react";
import { NavLink } from "react-router-dom";
import { useUserSessionStore } from "../../stores/UserSession.store";
import { UserTypeEnum } from "../../@core/enums/UserType.enum";

export interface CommonLayoutProps {
  children?: React.ReactNode;
}

const CommonLayout: FC<CommonLayoutProps> = ({ children }) => {
  const user = useUserSessionStore((state) => state.user);

  const renderNavLink = (to: string, label: string) => (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `block py-5 px-5 border-b-2 flex-shrink-0 ${
          !isActive ? "border-transparent" : "border-primary-500"
        }`
      }
    >
      {label}
    </NavLink>
  );

  const companyLinks = [
    { to: "/account-terms-and-conditions", label: "Terms & Conditions" },
    { to: "/account-faq", label: "FAQ" },
    { to: "/account-company-blog", label: "Blog" }
  ];

  return (
    <div className="nc-CommonLayoutProps bg-neutral-50 dark:bg-neutral-900">
      <div className="border-b border-neutral-200 dark:border-neutral-700 pt-12 bg-white dark:bg-neutral-800">
        <div className="container">
          <div className="flex flex-wrap overflow-x-auto hiddenScrollbar">
            {user.role === UserTypeEnum.COMPANY &&
              companyLinks.map((link) => renderNavLink(link.to, link.label))}
          </div>
        </div>
      </div>
      <div className="container pt-14 sm:pt-20 pb-24 lg:pb-32">{children}</div>
    </div>
  );
};

export default CommonLayout;
